import React, {Component} from 'react';
import {connect} from 'react-redux';
import {history} from '../../../../../store';
import IgniteDataTable from '../../../../common/datatable';
import ConfirmPopup from '../../../../common/confirm-popup';
import {deletePromotion} from '../../../../../actions/promotions';
import {dateFormat} from "../../../../../utils/commonFunctions";
import PropTypes from 'prop-types';

const columns = [
  {prop: 'product-name', title: 'Product'},
  {prop: 'groups-names', title: 'Group(s)'},
  {
    prop: 'outer-price',
    title: 'Promotion price',
    format: price => `€${price}`
  },
  {
    prop: 'display-from-date',
    title: 'Display from date',
    format: date => dateFormat(date)
  },
  {
    prop: 'display-to-date',
    title: 'Display to date',
    format: date => dateFormat(date)
  },
];

class PromotionsList extends Component {
  state = {
    delete: {
      show: false
    }
  };

  handleDelete = (result) => {
    const {dispatch} = this.props;
    const {id} = this.state.delete;
    this.setState({delete: {show: false}});
    if (result) {
      dispatch(deletePromotion(id));
    }
  };

  render() {
    const actions = [
      {
        label: 'Edit',
        permissions: {
          action: 'update',
          subjectClass: 'Promotion'
        },
        callback: (row) => {
          history.push(`/admin/promotions/${row.id}`);
        }
      },
      {
        label: 'Delete',
        permissions: {
          action: 'destroy',
          subjectClass: 'Promotion'
        },
        callback: (row) => {
          this.setState({delete: {show: true, id: row.id}});
        }
      }
    ];

    const {promotions} = this.props;
    const {delete: { show }} = this.state;

    return (
      <div>
        <IgniteDataTable
          data={promotions}
          columns={columns}
          actions={actions}
          pagination={{
            sizePerPage:  20,
          }}
        />
        {
          show &&
          <ConfirmPopup
            header="DELETE PROMOTION?"
            onClose={this.handleDelete}
          >
            <p>Are you sure you want to delete this price promotion?</p>
          </ConfirmPopup>
        }
      </div>
    )
  }
}

PromotionsList.propTypes = {
  fetching: PropTypes.bool,
  fetched: PropTypes.bool,
  promotions: PropTypes.array.isRequired,
};

export default connect()(PromotionsList)



// WEBPACK FOOTER //
// ./src/components/admin/promotions/promotions/list/price-promotions-list.jsx